import actions from './actions';

const initState = {
    data: [],
    selectedNotification: []
};

export default function NotificationReducer(state = initState, action) {
    switch (action.type) {
        case actions.NOTIFICATION_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        case actions.SELECTED_NOTIFICATION:
            return {
                ...state,
                selectedNotification: action.payload.data
            };
        default:
            return state;
    }
}
